import React from 'react';
import { TouchableOpacity, Image, useWindowDimensions } from 'react-native';
import { useMapStore, type MapMarkerData } from 'src/domain/stores/useMapStore';
import Icons from 'src/core/utils/Icons';

interface MarkerProps {
	x: number;
	y: number;
	color: string;
	data: MapMarkerData;
}

function getMarkerImage(color: string) {
	switch (color) {
		case 'yellow-blue':
			return Icons.mapHotspotYellow;
		case 'yellow-white':
			return Icons.mapHotspotYellowWhite;
		case 'blue-white':
			return Icons.mapHotspotBlue;
		case 'blue-yellow':
			return Icons.mapHotspotBlueYellow;
		case 'white-blue':
			return Icons.mapHotspotWhite;
		default:
			return Icons.mapHotspotYellow;
	}
}

function Marker({ x, y, color, data }: MarkerProps) {
	const mapStore = useMapStore();
	// The column is full height, so the window height is the height available here.
	const { height } = useWindowDimensions();

	let markerWidth: number;
	let markerHeight: number;

	if (mapStore.mapScale > 3 && mapStore.mapScale < 7) {
		markerWidth = 15;
		markerHeight = 18;
	} else if (mapStore.mapScale >= 7 && mapStore.mapScale < 240) {
		markerWidth = 8;
		markerHeight = 9.6;
	} else {
		markerWidth = 25;
		markerHeight = 30;
	}

	const markerImage = getMarkerImage(color);

	return (
		<TouchableOpacity
			style={{
				position: 'absolute',
				left: x - markerWidth / 2,
				top: height < 600 ? y - markerHeight + 8 : y - markerHeight + 5,
			}}
			onPress={() => mapStore.showMarkerInfo(data)}
		>
			<Image
				capInsets={{ left: 0.1, top: 0.1, right: 0.1, bottom: 0.1 }}
				source={markerImage}
				style={{
					width: markerWidth,
					height: markerHeight,
				}}
			/>
		</TouchableOpacity>
	);
}

export default Marker;
